import React from 'react';
import { Button, Modal, Typography, makeStyles } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  container: {
    backgroundColor: 'white',
    padding: theme.spacing(4),
    borderRadius: '8px',
    outline: 'none',
    width: '400px',
    textAlign: 'center',
  },
  title: {
    fontFamily: 'Quicksand, sans-serif',
    fontSize: '1.25rem',
    color: '#1c2434',
    lineHeight: '2rem',
    fontWeight: 600,
    textAlign: 'center',
    marginBottom: theme.spacing(3),
  },
  textField: {
    fontFamily: 'Quicksand, sans-serif',
    fontSize: '1rem',
    color: '#1c2434',
    lineHeight: '1rem',
    fontWeight: 450,
    textAlign: 'left',
    marginBottom: theme.spacing(2),
    marginLeft: theme.spacing(2),
  },
}));

interface IModalReasonRefusal {
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  onClick: () => void;
  drivers: any;
}

const ModalDriverNotification: React.FC<IModalReasonRefusal> = ({
  open,
  setOpen,
  onClick,
  drivers,
}) => {
  const classes = useStyles();
  const driversLength = drivers.length;

  const handleDriverMessage = (pushNotificationToken: number) => {
    console.log(`Enviando mensagem para: ${pushNotificationToken}`);
  };

  return (
    <Modal open={open} onClose={() => setOpen(false)} className={classes.modal}>
      <div className={classes.container}>
        <Typography className={classes.title}>Envio de Notificação</Typography>
        <div>
          {driversLength === 0 ? (
            <p className={classes.title}>
              Nenhum motorista disponível no momento.
            </p>
          ) : (
            <p className={classes.title}>
              Deseja enviar para todos os {driversLength} motoristas
              disponíveis?
            </p>
          )}
        </div>

        {driversLength > 0 && (
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-evenly',
              marginTop: '1rem',
            }}
          >
            <Button
              className="primary-button"
              variant="contained"
              onClick={() => {
                drivers.forEach((driver: { pushNotificationToken: number }) => {
                  handleDriverMessage(driver.pushNotificationToken);
                });
                setOpen(false);
              }}
            >
              Sim
            </Button>

            <Button
              className="primary-button outline"
              onClick={() => setOpen(false)}
            >
              Não
            </Button>
          </div>
        )}
      </div>
    </Modal>
  );
};

export default ModalDriverNotification;
